import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { logout } from '../store/actions/auth.actions';
import { selectIsConnected } from '../store/selectors/auth.selectors';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(
    private injector: Injector,
    private store: Store
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const toaster = this.injector.get(ToastController);
    return next.handle(request).pipe(
      catchError(error => {
        if (error.status === 401) {
          // Only a connected session can be logged out. On the login page a 401
          // just means "not connected yet": dispatching logout() there puts the
          // auth state in loading (hiding the submit button) for nothing.
          this.store
            .select(selectIsConnected)
            .pipe(take(1))
            .subscribe((isConnected: boolean) => {
              if (isConnected) {
                this.store.dispatch(logout());
              }
            });
          return throwError(error);
        } else if (error.status === 500) {
          toaster.create({
            message: 'Une erreur avec le serveur a eu lieu',
            duration: 2000,
            position: 'top',
            color: 'danger'
          }).then(toast => {
            toast.present();
          });
          return throwError(error);
        } else {
          return throwError(error);
        }
      })
    );
  }
}
